module.exports = __webpack_public_path__ + "static/media/text-width.b5d3a298.svg";